import { Injectable, Injector } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpEventType,
} from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { ApiService } from "../services/api.service";
import { AuthService, LocalService } from "../services";

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private apiService: ApiService,
    readonly authService: AuthService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<Object>) => {
          // if (event.type === HttpEventType.Response || event instanceof HttpResponse) {}
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            // console.log(err.status);
            // console.log(err.statusText);
            if ( err.status === 403) {
              LocalService.flush("token");
              LocalService.flush("userProfile");
              this.authService.clearAll();
              window.open("/", "_self");
              //this.router.navigate(['/']);
            }
            if (err.status === 503 || err.status === 404) {
              this.apiService
                .get(
                  "https://slrrwd-maintenance-api-rcdn-prod.cisco.com/api/rest/maintenance"
                )
                .subscribe((res) => {
                  // console.log(res)
                  if (res.underMaintenance === true) {
                    LocalService.flush("token");
                    LocalService.flush("userProfile");
                    this.authService.clearAll();
                    this.router.navigate(["/maintenance"]);
                  }
                });
            }
          }
        }
      )
    );
  }
}
